import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import AllowanceReason from "./AllowanceReason";

const CallAllowanceReason = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <AllowanceReason />
        </div>
    );
}

export default CallAllowanceReason;